<template>
    <div class="task-payment-record member-tab">
        <div class="wallet-tool-bar">
            <div class="filter" :class="{'fixed': listIsFixed}">
                <rent-select refName="payWay" selectMsg="所有方式" @getId="getSelectId" border="1px solid #d5dad8" bgColor="#fff" :setDefault="isDefault">
                    <ul>
                        <li data-id="WALLET">{{transPayWay('WALLET')}}</li>
                        <li data-id="TRANSFER">{{transPayWay('TRANSFER')}}</li>
                    </ul>
                </rent-select>
                <date-picker v-model="filter.date" :class="{'active': filter.date.length >0}" placeholder="請選擇日期" format="YYYY.MM.DD"  rangeSeparator="-" range value-type="timestamp" ></date-picker>
            </div>
        </div>
        <div  class="table-list">
            <div class="table-list-title">
                <span class="date">時間</span>
                <span class="house">房源名稱</span>
                <span class="item">項目</span>
                <span class="amount">金額</span>
                <span class="pay-way">付款方式</span>
                <span class="order-num">訂單編號</span>
            </div>
            <div class="table-list-body" >
                <div v-show="filterByContractDate.length == 0 && incomeAndExpenditure.length != 0" class="filter-empty">
                    <span>0 個搜尋結果</span>
                    <button class="default-button" @click="setFilterDefault">清除篩選</button>
                </div>
                <div v-if="incomeAndExpenditure.length == 0" class="is-empty">0 筆資料</div>
                <ul>
                    <li v-for="(list,index) in filterByContractDate" :key="index">
                        <span class="date">{{list.transactionDate}}</span>
                        <span class="house">{{list.houseName}}</span>
                        <span class="item">
                            {{transSource(list.source)}}
                        </span>
                        <span v-if="list.type == 'INCOME'" class="amount blue">+ {{toCurrency(list.amountFormatString)}}</span>
                        <span v-else class="amount red">- {{toCurrency(list.amountFormatString)}}</span>
                        <span class="pay-way">{{transPayWay(list.paymentType)}}</span>
                        <span class="order-num">{{list.referenceSeq}}</span>
                    </li>
                </ul>
            </div> 
        </div>
    </div>
</template>
<script>
import RentSelect from '@/components/widge/RentSelect.vue';
import DatePicker from 'vue2-datepicker';
import walletStoredInfo from '@/components/widge/modal/walletStoredInfo.vue';

import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            isDefault: false,
            filter: {
                payWay: null,
                date: []
            },
            listIsFixed: false
        }
    },
    mounted () {
        this.$store.dispatch('getUserBalance')
        this.$store.dispatch('getIncomeAndExpenditureMgtList')
    },
    created () {
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed () {
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        handleScroll (event) {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
        
            if( scrollTop >= 115){
                this.listIsFixed = true
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }
        },
        getSelectId: function (value) {
            this.isDefault = false
            if( value.ref == 'source' ){
                this.filter.source = value.id
            }else if( value.ref == 'payWay' ){
                this.filter.payWay = value.id
            }
        },
        setFilterDefault: function () {
            this.filter = {
                source: null,
                payWay: null,
                date: []
            }
            this.isDefault = true
        },
        getFormatDate: function (time){
            var formatDate = [];
            var date = new Date();
            //一般日期 年 月 天 時 分
            formatDate[0] = date.getFullYear();
            formatDate[1] = date.getMonth()+1;
            formatDate[2] = date.getDate();
            formatDate[3] = (Array(2).join(0)+date.getHours(-8)).slice(-2);
            formatDate[4] = (Array(2).join(0)+date.getMinutes()).slice(-2);
            formatDate[5] = (Array(2).join(0)+date.getSeconds()).slice(-2);
            //月及天兩位數
            formatDate[6] = (Array(2).join(0)+formatDate[1]).slice(-2);
            formatDate[7] = (Array(2).join(0)+formatDate[2]).slice(-2);
            // console.log(formatDate[3] )
            //換算時區 台灣-8
            // if(formatDate[3] - 8 < 0){
            //     formatDate[3] = 24+(formatDate[3]-8);
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }else{
            //     formatDate[3] = formatDate[3]-8;
            //     formatDate[3] = (Array(2).join(0)+formatDate[3]).slice(-2);
            // }
            return formatDate[0]+'-'+formatDate[6]+'-'+formatDate[7]+' '+formatDate[3]+':'+formatDate[4];
        },
        // transSource: function (value) {
        //     if( value == 'BOOKING_DEPOSIT' ){
        //         return '訂金'
        //     }else if( value == 'CONTRACT_DEPOSIT' ) {
        //         return '押金'
        //     }else if( value == 'CONTRACT_BILL' ) {
        //         return '帳單'
        //     }else if( value == 'HOUSE_TASK_BONUS' ) {
        //         return '委託獎金'
        //     }else if(value == 'HOUSE_LEDGER'){
        //         return '記帳'
        //     }else if(value == 'RETURN_PAID_HOUSE_TASK_BONUS'){
        //         return '委託退款'
        //     }else if(value == 'BOOKING_DEPOSIT_FOR_TENANT_REJECT'){
        //         return '取消預定'
        //     }
        // },
        // transPayWay: function (value) {
        //     if( value == 'WALLET' ){
        //         return '飛豬錢包'
        //     }else if( value == 'TRANSFER' ) {
        //         return '匯款轉帳'
        //     }else if( value == 'TASK_REFUND' ) {
        //         return '系統退款'
        //     }else if( value == 'DEPOSIT_FORFEIT' ) {
        //         return '訂金補償'
        //     }
        // },
        // transType: function (value) {
        //     if( value == 'INCOME' ){
        //         return '收入'
        //     }else if( value == 'EXPENSE' ) {
        //         return '支出'
        //     }
        // },
        // toCurrency: function (num){
        //     var parts = num.toString().split('.');
        //     // console.log(parts);
        //     parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        //     return parts.join('.');
        // },
    },
    computed: {
        filterByType: function () {
            return this.incomeAndExpenditure.filter((item) => {
                if(item.type == 'EXPENSE'){
                    return item
                }
                
            });
        },
        filterBySource: function () {
            return this.filterByType.filter((item) => {
                if(item.source == 'HOUSE_TASK_BONUS'){
                    return item
                }
            });
        },
        filterByPayWay: function () {
            return this.filterBySource.filter((item) => {
                if(this.filter.payWay){
                    if(item.paymentType == this.filter.payWay){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        filterByContractDate: function () {
            return this.filterByPayWay.filter((item) => {
                if( this.filter.date[0] && this.filter.date[1] ){
                    let transDate = new Date(item.transactionDate),
                        filterDateStart = this.filter.date[0],
                        filterDateEnd = this.filter.date[1]+86400000
                    if( filterDateStart <= transDate && transDate <= filterDateEnd ){
                        return item
                    }
                }else{
                    return item
                }
            });
        },
        ...mapGetters({
            userBalance: 'GET_USER_BALANCE',
            incomeAndExpenditure: 'GET_INCOME_EXPENDITURE_MGT_LIST',
        })
    },
    components: {
        RentSelect,
        DatePicker,
        walletStoredInfo
    }
}
</script>
<style lang="scss" scoped>
    .task-payment-record{
        width: 1094px;
        padding: 30px;
        .wallet-tool-bar{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;
            .filter.fixed{
                position: fixed;
                z-index: 50;
                margin-left: 786px;
                background: #fff;
                top: 0px;
                height: 80px;
                align-items: center;
            }
            .filter{
                display: flex;
                .rent-select{
                    width: 75px;
                }
                .mx-datepicker{
                    width: 214px;
                    input{
                        width: 100%;
                        height: 44px;
                        border-radius: 4px;
                        border: solid 1px #e0dfde;
                        color: #a8a5a4;
                        padding: 13px 16px;
                        box-shadow: none;
                        margin-bottom: 0px;
                    }
                    .mx-icon-calendar,
                    .mx-icon-clear{
                        right: 14px;
                    }
                }
                .mx-datepicker:hover,
                .mx-datepicker.active{
                    input{
                        border: 1px solid #676362 !important;
                        color: #676362 !important;
                    }
                    i{
                        color: #676362;
                    }
                }
            }
            .filter{
                .rent-select{
                    margin-right: 16px;
                }
            }
            .stored{
                display: flex;
                .money{
                    position: relative;
                    display: flex;
                    align-items: center;
                    .sign{
                        color: #292625;
                        margin-right: 4px;
                    }
                    .number{
                        color: #ff9275;
                        margin-left: 6px;
                        font-size: 28px;
                    }
                }
            }
        }
        >.table-list{
            position: relative;
            width: 1094px;
            border-radius: 0px;
            border: 0px;
            // border-bottom: 1px solid #f0f0f0;
            border-top: 1px solid #f0f0f0;
            .table-list-title .date,
            .table-list-body ul li .date{
                width: 112px;
                margin-right: 83px;
            }
            .table-list-title .house,
            .table-list-body ul li .house{
                position: relative;
                width: 160px;
                margin-right: 93px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
            }
            .table-list-title .item,
            .table-list-body ul li .item{
                width: 56px;
                margin-right: 94px;
            }
            .table-list-title .amount,
            .table-list-body ul li .amount{
                width: 83px;
                margin-right: 93px;
                text-align: right;
            }
            // .table-list-body ul li .amount{
            //     text-align: right;
            // }
            .table-list-body ul li .amount.blue{
                color: #3942b5;
            }
            .table-list-body ul li .amount.red{
                color: #ff9275;
            }
            .table-list-title .pay-way,
            .table-list-body ul li .pay-way{
                width: 56px;
                margin-right: 93px;
            }
            // .table-list-title .trans-people,
            // .table-list-body ul li .trans-people{
            //     width: 146px;
            //     margin-right: 35px;
            // }
        }
    }
    @media screen and (max-width: 1280px) {
        .task-payment-record{
            width: 1080px;
            .wallet-tool-bar{
                .filter.fixed{
                    margin-left: 771px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/landlord/houseStatus/memberCenter/taskPaymentRecord.vue